import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Strada Create Campaign Call v1 Configuration Validator
 * Validates campaign call creation with campaign selection and agent validation
 */
export const Strada_Create_Campaign_Call_1_ConfigValidator = z
    .object({
    newCampaignName: z.string().max(40, 'Campaign name cannot be more than 40 characters long').optional(),
    existingCampaignName: z
        .string()
        .max(40, 'Campaign name cannot be more than 40 characters long')
        .optional(),
    agentId: requiredString('Agent ID is required'),
    scheduleId: requiredString('Schedule ID is required'),
    phoneNumber: requiredString('Phone number is required'),
    phoneNumberId: requiredString('Phone number ID is required'),
    callRetryConfigId: z.string().nullable().optional(),
    requestVariables: z.record(z.string(), z.string().optional()).optional()
})
    .refine((data) => data.newCampaignName || data.existingCampaignName, {
    path: ['campaign'],
    error: 'Either new campaign name or existing campaign name must be provided'
});
//# sourceMappingURL=strada-create-campaign-call-1.js.map